// this code must execute before the app is loaded in order to set the organizationId from the link before redirect to DAP

class EmailHandler {
  ORG_ID_KEY = 'debrisflow-redirect-organization-id'
  ORG_TIME_KEY = 'debrisflow-redirect-organization-time'

  handleEmailLink() {
    try {
      const url = new URL(window.location.href)
      const isEmailLink = url.searchParams.get('email') === 'true'
      if (isEmailLink) {
        // check for email fields and remove them from the URL
        this.removeEmailFields(url)
      } else {
        // this should happen on the reload after the email params have been removed and the organizationId has been stored
        this.checkForEmailOrgId()
      }
    } catch (error) {
      console.error(error)
      sessionStorage.removeItem(this.ORG_ID_KEY)
      sessionStorage.removeItem(this.ORG_TIME_KEY)
    }
  }

  checkForEmailOrgId() {
    const orgId = sessionStorage.getItem(this.ORG_ID_KEY)
    if (orgId) {
      sessionStorage.removeItem(this.ORG_ID_KEY)
      const timeAdded = sessionStorage.getItem(this.ORG_TIME_KEY)
      if (timeAdded) {
        sessionStorage.removeItem(this.ORG_TIME_KEY)
        // check if the organizationId was added within the last 5 seconds allowing time for the page to reload but not too long to be stale
        const expiration = new Date(timeAdded)
        expiration.setSeconds(expiration.getSeconds() + 5)
        if (new Date() < expiration) {
          // set the organizationId to the window object so it can be used for the environment property
          window.directLinkOrganizationId = orgId
        }
      }
    }
  }

  removeEmailFields(url) {
    url.searchParams.delete('email')
    const organizationId = url.searchParams.get('organizationId')
    if (organizationId) {
      sessionStorage.setItem(this.ORG_ID_KEY, organizationId)
      sessionStorage.setItem(this.ORG_TIME_KEY, new Date().toISOString())
    }
    if (url.href !== window.location.href) {
      // navigate to the new url without the email query params; this should cause an immediate reload of the page
      window.location = url.href
    }
  }
}

new EmailHandler().handleEmailLink()
  